import SubPage from "../subpages/SubPage";
import { Switch, Route } from "react-router-dom";
import { Container } from "react-bootstrap";
import PersonalRecord from "../subpages/PersonalRecord";
import TotalRecord from "../subpages/TotalRecord";
import UntactRecord from "../subpages/UntactRecord";
import PrintRecord from "../subpages/PrintRecord";
import UntactRank from "../components/UntactRank";

const Record = () => {
  const title = "기록 조회";
  const parent_link = "record";
  const side_list = [
    ["", "개인 기록 조회"],
    ["total", "종합 기록 조회"],
    ["rank", "언택트 순위"],
    ["untact", "언택트 기록 조회"],
    // ['print-record', '기록증 출력'],
  ];
  const bg_info = {
    link: "/record_banner.jpeg",
    text: title,
  };
  return (
    <div style={{ minHeight: "70rem" }}>
      <SubPage
        title={title}
        parent_link={parent_link}
        side_list={side_list}
        background_info={bg_info}
      />
      <Container className="col-10 offset-1 col-lg-8 offset-lg-3">
        <Switch>
          <Route
            path={`/${parent_link}`}
            component={PersonalRecord}
            exact={true}
          />
          <Route path={`/${parent_link}/total`} component={TotalRecord} />
          <Route path={`/${parent_link}/untact`} component={UntactRecord} />
          <Route path={`/${parent_link}/rank`} component={UntactRank} />
          <Route
            path={`/${parent_link}/print-record`}
            component={PrintRecord}
          />
        </Switch>
      </Container>
    </div>
  );
};
export default Record;
